import { MDCDialog } from '@material/dialog';

const props = {
    dialogObject: null
};

export const dialogModel = {
    title: '',
    content: '',
    displayConfirm: true,
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    onConfirm: null,
    theme: 'default'
};

export function mapDialog(model) {
    const dialog = $('#mdc-dialog');

    dialog.attr('data-mdc-dialog-theme', model.theme);

    dialog.find('.mdc-dialog__title').text(model.title);
    dialog.find('.mdc-dialog__content').text(model.content);
    dialog.find('.mdc-button__label-cancel').text(model.cancelButtonText);
    dialog.find('.mdc-button__label-confirm').text(model.confirmButtonText);

    if (!model.displayConfirm) {

        dialog.find('.mdc-dialog__button-confirm').hide();
    }
    else {

        dialog.find('.mdc-dialog__button-confirm').show();
    }

    if (model.onConfirm)
        dialog.find('.mdc-dialog__button-confirm').off('click').on('click', () => model.onConfirm());
    else
        dialog.find('.mdc-dialog__button-confirm').off('click');
}

export function initDialog() {
    const dialogElm = document.getElementById('mdc-dialog');
    const dialog = new MDCDialog(dialogElm);

    props.dialogObject = dialog;

    dialog.listen('MDCDialog:closed', () => {
        mapDialog({ ...dialogModel });
    });
}

export function openDialog(model) {
    const dialog = props.dialogObject;
    if (dialog) {
        mapDialog(model);
        dialog.open();
    }
}